import axios from 'axios'
import { API_URL } from '../api.js'

const api = `${API_URL}/invoice`

export default {
    async getInvoice(invoiceId, filename) {
        console.log(invoiceId, filename)
        const resp = await axios.get(`${api}/${invoiceId}`, { responseType: 'arraybuffer' });

        const arr = new Uint8Array(resp.data);
        const blob = new Blob([arr], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob)

        let link = document.createElement('a')
        link.href = url
        link.download = `${filename}.pdf`
        link.click()
    }
}